import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const footerLinks = {
    product: [
      { label: 'Features', href: '/features' },
      { label: 'Pricing Plans', href: '/pricing' },
      { label: 'Pricing Estimator & ROI', href: '/hospital-software-price-india' },
      { label: 'NABH Billing Software', href: '/features/nabh-medical-billing' },
      { label: 'OPD Software', href: '/services/opd-management-software' },
      { label: 'IPD Software', href: '/services/ipd-management-software' },
      { label: 'Lab Software (LIS)', href: '/services/lab-management-software' }
    ],
    solutions: [
      { label: 'For Multi-Specialty Hospitals', href: '/solutions/for-multi-specialty-hospitals' },
      { label: 'For Polyclinics & Clinics', href: '/solutions/for-clinics-and-polyclinics' },
      { label: 'For Nursing Homes (India)', href: '/nursing-home-software-india' },
      { label: 'For Diagnostic Centres', href: '/diagnostic-centre-software-india' },
      { label: 'Small Hospital EMR', href: '/emr-software-small-hospital' },
      { label: 'ABHA/ABDM Integrated HMS', href: '/abha-integration-hospital' }
    ],
    resources: [
      { label: 'Help Center', href: '#' },
      { label: 'Case Studies', href: '#' },
      { label: 'Webinars', href: '#' },
      { label: 'White Papers', href: '#' }
    ],
    company: [
      { label: 'About Us', href: '/about' },
      { label: 'Careers', href: '#' },
      { label: 'Press', href: '#' },
      { label: 'Partners', href: '#' },
      { label: 'Contact', href: '/contact' },
      { label: 'Investors', href: '#' }
    ],
    legal: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'Cookie Policy', href: '#' },
      { label: 'HIPAA Compliance', href: '#' },
      { label: 'Security', href: '#' },
      { label: 'Accessibility', href: '#' }
    ]
  };

  // Social links (currently not rendered). If needed, uncomment footer social section.

  const handleLinkClick = (href) => {
    if (href.startsWith('#')) {
      const element = document.getElementById(href.substring(1));
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  const FooterLink = ({ link }) => {
    if (link.href.startsWith('/')) {
      return (
        <Link to={link.href} className="footer-link">
          {link.label}
        </Link>
      );
    }
    return (
      <a
        href={link.href}
        onClick={(e) => {
          if (link.href.startsWith('#')) {
            e.preventDefault();
            handleLinkClick(link.href);
          }
        }}
        className="footer-link"
      >
        {link.label}
      </a>
    );
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Company Info */}
          <div className="footer-brand">
            <div className="footer-logo">
              <div className="logo-icon">
                <img src={process.env.PUBLIC_URL + '/logo.png'} alt="Mediway Nextgen logo" />
              </div>
              <div className="logo-text">
                <span className="logo-title">Mediway Nextgen</span>
                <span className="logo-subtitle">by Wayug • Hms</span>
              </div>
            </div>

            <p className="footer-description">
              Transforming healthcare operations with our intelligent hospital management software.
              Trusted by over 5+ hospitals across india to deliver exceptional patient care.
            </p>

            <div className="footer-contact">
              <div className="contact-item">
                <span className="contact-icon">📞</span>
                <a href="tel:+918287999236" className="contact-link">8287999236</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">✉️</span>
                <a href="mailto:wayugpl@gmail.com" className="contact-link" rel="nofollow">wayugpl@gmail.com</a>
              </div>
              <div className="contact-item">
                <span className="contact-icon">📍</span>
                <span className="contact-text">Connaught Place, New Delhi, Delhi, India</span>
              </div>
            </div>

            {/* <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="social-link"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={`Follow us on ${social.name}`}
                >
                  {social.icon}
                </a>
              ))}
            </div> */}
          </div>

          {/* Footer Links */}
          <div className="footer-links">
            <div className="link-section">
              <h4>Product</h4>
              <ul>
                {footerLinks.product.map((link, index) => (
                  <li key={index}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </div>

            <div className="link-section">
              <h4>Solutions</h4>
              <ul>
                {footerLinks.solutions.map((link, index) => (
                  <li key={index}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </div>

            <div className="link-section">
              <h4>Resources</h4>
              <ul>
                {footerLinks.resources.map((link, index) => (
                  <li key={index}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </div>

            <div className="link-section">
              <h4>Company</h4>
              <ul>
                {footerLinks.company.map((link, index) => (
                  <li key={index}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </div>

            <div className="link-section">
              <h4>Legal</h4>
              <ul>
                {footerLinks.legal.map((link, index) => (
                  <li key={index}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Newsletter Signup
        <div className="footer-newsletter">
          <div className="newsletter-content">
            <div className="newsletter-info">
              <h4>Stay Updated</h4>
              <p>Get the latest healthcare technology insights and product updates delivered to your inbox.</p>
            </div>
            <div className="newsletter-form">
              <div className="newsletter-input">
                <input 
                  type="email" 
                  placeholder="Enter your email address" 
                  className="email-input"
                />
                <button className="btn btn-primary newsletter-btn">
                  Subscribe
                </button>
              </div>
              <p className="newsletter-note">
                Join 10,000+ healthcare professionals. Unsubscribe at any time.
              </p>
            </div>
          </div>
        </div> */}

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; 2024 Wayug Infotech Solutions Limited. All rights reserved.</p>
            </div>

            <div className="footer-certifications">
              <div className="certification-badge">
                <span>🔒 HIPAA Compliant</span>
              </div>
              <div className="certification-badge">
                <span>🛡️ SOC 2 Certified</span>
              </div>
              <div className="certification-badge">
                <span>⭐ ISO 27001</span>
              </div>
            </div>

            <div className="footer-made-with">
              <p>Made with ❤️ for Healthcare</p>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-background">
        <div className="background-gradient"></div>
      </div>
    </footer>
  );
};

export default Footer;